import React, { useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./Forgot-Password.css"; 
import { API_URL } from "../../constant"; 

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);

  const containerStyle = {
    minHeight: "100vh",
    fontFamily: "Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: "30px",
  };

  const formWrapperStyle = {
    display: "flex",
    justifyContent: "center",
    padding: "0px",
    flex: 1,
    boxSizing: "border-box",
    marginTop: "120px",
    width: "100%",
    marginBottom: "120px",
  };

  const formCardStyle = {
    backgroundColor: "#ffffff",
    padding: "64px",
    borderRadius: "17.6px",
    width: "100%",
    maxWidth: "600px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
    boxSizing: "border-box",
  };

  const headingStyle = {
    textAlign: "center",
    fontSize: "28px",
    fontWeight: "900",
    marginBottom: "4px",
    background: "linear-gradient(90deg, #2D4CA8 52%, #9F4AFF 60%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  const subheadingStyle = {
    fontFamily: "Inter, sans-serif",
    textAlign: "center",
    color: "#696969",
    fontWeight: "normal",
    fontSize: "16px",
    marginBottom: "24px",
  };

  const labelStyle = {
    fontWeight: "600",
    fontSize: "16px",
    color: "#052C65",
    marginBottom: "6px",
    display: "block",
  };

  const inputStyle = {
    width: "100%",
    height: "40px",
    padding: "9px",
    borderRadius: "12px",
    border: "1px solid #ccc",
    fontSize: "14px",
    boxSizing: "border-box",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "15%",
    marginTop: "60px",
    marginBottom: "60px",
  };

  const primaryButtonStyle = {
    width: "30%",
    padding: "12px",
    backgroundColor: "#0000A0",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "16px",
  };

  const messageStyle = {
    textAlign: "center",
    padding: "10px",
    borderRadius: "8px",
    margin: "20px 0",
    fontWeight: "500",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ text: "", type: "" });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setMessage({ text: "Please enter a valid email address", type: "error" });
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/agent/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          text: "Verification code sent to your email",
          type: "success"
        });
        
        // Store email for verification page
        localStorage.setItem('reset_email', email);
        
        // Redirect to verify email page after a short delay
        setTimeout(() => {
          window.location.href = "/verify-email-ap?purpose=password_reset";
        }, 2000);
      } else {
        // Handle specific error cases
        if (response.status === 404) {
          setMessage({
            text: "Email not found. Please check your email address or register for a new account.",
            type: "error"
          });
        } else if (response.status === 429) {
          setMessage({
            text: "Too many attempts. Please try again later.",
            type: "error"
          });
        } else {
          setMessage({
            text: data.message || "Failed to send verification code. Please try again.",
            type: "error"
          });
        }
      }
    } catch (error) {
      setMessage({
        text: "An error occurred. Please try again later.",
        type: "error"
      });
    } finally {
      setIsLoading(false);
    }
  };
  // Function to handle cancel action
  const handleCancel = () => {
    window.location.href = "/work-with-tcuk";
  };

  return (
    <div style={{ ...containerStyle, minHeight: "auto" }}>
      <Header />

      <div style={formWrapperStyle}>
        <div
          className="form-card1 p-4 m-3 pt-5 h-auto"
          style={{ ...formCardStyle, minHeight: "auto" }}
        >
          <h2 style={headingStyle}>Send Verification Code</h2>
          <p style={subheadingStyle}>
            Please enter your email address to receive your verification code
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "16px" }} className="form-group">
              <label style={labelStyle}>Email</label>
              <input
                type="email"
                placeholder="johnwick01@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
                required
                disabled={isLoading}
              />
            </div>
            {message.text && (
              <div
                style={{
                  ...messageStyle,
                  backgroundColor:
                    message.type === "error" ? "#ffebee" : "#e8f5e9",
                  color: message.type === "error" ? "#c62828" : "#2e7d32",
                }}
              >
                {message.text}
              </div>
            )}
            <div style={buttonContainerStyle} className="button-container">
              {/* Cancel Button */}
              <button
                type="button"
                style={{
                  ...primaryButtonStyle,
                  backgroundColor: "#ffffff",
                  color: "#052C65",
                  border: "1px solid #052C65",
                }}
                onClick={handleCancel}
                disabled={isLoading}
              >
                Cancel
              </button>

              {/* Send Button */}
              <button
                type="submit"
                style={{
                  ...primaryButtonStyle,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                onMouseOver={(e) =>
                  !isLoading && (e.target.style.backgroundColor = "#1a1aa0")
                }
                onMouseOut={(e) =>
                  !isLoading && (e.target.style.backgroundColor = "#0000A0")
                }
                disabled={isLoading}
              >
                {isLoading ? "Sending..." : "Send"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ForgotPassword;
